// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as BusinessSlugRouteImport } from './routes/business/$slug'
import { Route as BrandSlugRouteImport } from './routes/brand/$slug'
import { Route as BusinessSlugProfileRouteImport } from './routes/business/$slug_.profile'
import { Route as BusinessSlugOrderPendingRouteImport } from './routes/business/$slug_.order-pending'
import { Route as BusinessSlugOrderConfirmRouteImport } from './routes/business/$slug_.order-confirm'
import { Route as BusinessSlugCheckoutRouteImport } from './routes/business/$slug_.checkout'
import { Route as BusinessSlugCartRouteImport } from './routes/business/$slug_.cart'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const BusinessSlugRoute = BusinessSlugRouteImport.update({
            id: '/business/$slug',path: '/business/$slug',getParentRoute: () => rootRouteImport
          })
const BrandSlugRoute = BrandSlugRouteImport.update({
            id: '/brand/$slug',path: '/brand/$slug',getParentRoute: () => rootRouteImport
          })
const BusinessSlugProfileRoute = BusinessSlugProfileRouteImport.update({
            id: '/business/$slug_/profile',path: '/business/$slug/profile',getParentRoute: () => rootRouteImport
          })
const BusinessSlugOrderPendingRoute = BusinessSlugOrderPendingRouteImport.update({
            id: '/business/$slug_/order-pending',path: '/business/$slug/order-pending',getParentRoute: () => rootRouteImport
          })
const BusinessSlugOrderConfirmRoute = BusinessSlugOrderConfirmRouteImport.update({
            id: '/business/$slug_/order-confirm',path: '/business/$slug/order-confirm',getParentRoute: () => rootRouteImport
          })
const BusinessSlugCheckoutRoute = BusinessSlugCheckoutRouteImport.update({
            id: '/business/$slug_/checkout',path: '/business/$slug/checkout',getParentRoute: () => rootRouteImport
          })
const BusinessSlugCartRoute = BusinessSlugCartRouteImport.update({
            id: '/business/$slug_/cart',path: '/business/$slug/cart',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,BrandSlugRoute: BrandSlugRoute,BusinessSlugRoute: BusinessSlugRoute,BusinessSlugCartRoute: BusinessSlugCartRoute,BusinessSlugCheckoutRoute: BusinessSlugCheckoutRoute,BusinessSlugOrderConfirmRoute: BusinessSlugOrderConfirmRoute,BusinessSlugOrderPendingRoute: BusinessSlugOrderPendingRoute,BusinessSlugProfileRoute: BusinessSlugProfileRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)